module.exports = __webpack_public_path__ + "static/mos-cdcee9e85d48c8b2a53a1d1cb39d4791.jpg";